import React, {useContext, useState, useEffect} from 'react';
import {AppContext} from '../../context/app/appContext';
import {Button, Dimmer, Loader, Modal, Progress, Input, Label, Divider} from 'semantic-ui-react';
import axios from 'axios';

const url = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';
const accessToken = localStorage.getItem('accessToken');
const date = new Date();
const dateToDisplay = ("0"+(date.getMonth()+1)).slice(-2) + '/' + ("0"+date.getDate()).slice(-2) + '/' + date.getFullYear();


export const SettingsAccount = () => {

    const appContext = useContext(AppContext);
    const [issuingBalance, setIssuingBalance] = useState(0);
    // const [balanceRequired, setBalanceRequired] = useState(0);
    const [percent, setPercent] = useState(0);
    const [receiptUploadDays, setReceiptUploadDays] = useState(appContext.organization.receiptUploadDays ? appContext.organization.receiptUploadDays : 7)
    const [minimumReceiptAmount, setMinimumReceiptAmount] = useState(appContext.organization.minimumReceiptAmount ? appContext.organization.minimumReceiptAmount : 75)
    const [currentUploadDays, setCurrentUploadDays] = useState(receiptUploadDays);
    const [currentReceiptAmount, setCurrentReceiptAmount] = useState(minimumReceiptAmount);
    // const [incorrectAmount, setIncorrectAmount]  =useState(false);
    // const [incorrectDays, setIncorrectDays]  =useState(false);
    const [saveModal, setSaveModal] = useState(false);
    // const [incorrectInputModal, setIncorrectInputModal] = useState(false);
    const [apiSuccessModal, setApiSuccessModal] = useState(false);
    const [apiFailureModal, setApiFailureModal] = useState(false)
    
    useEffect(() => {
        (async function getBalance(){
            await axios.get(url + '/get-org-balance', {
                headers : {
                    Authorization: `Bearer ${accessToken}`,
                }
            }).then(response => {
                console.info(response);
                if(response.status === 200){
                    if(response.data && response.data.data){
                        const issuing = response.data.data.issuing;
                        setIssuingBalance(issuing.available[0].amount / 100);
                        console.log(issuing.available[0].amount / 100)
                    }else{
                        console.log("No data received!")
                    }
                }else{
                    console.log('Negative response from Balance API')
                }
            }).catch(error => {
                console.log(error);
            })
        })();
    }, [])

    useEffect(() => {
        if (!appContext.teams.length) {
            (async function loadTeams() {
                await appContext.loadTeams();
            })();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!appContext.employees.length) {
            (async function loadEmployees() {
                await appContext.setEmployees();
            })();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        var total = 0;
        console.log("Teams")
        appContext.teams.forEach(team => {
            if(team.budget > 0){
                var numPerkEmployees = appContext.employees.filter(employee => {return (employee.teamId === team.id)}).length
                total += numPerkEmployees * team.budget;
            }
            if(team.expenseLimit > 0){
                var numExpenseEmployees = appContext.employees.filter(employee => {return (employee.teamId === team.id && (employee.expenseStatus === 'activateHR' || employee.expenseStatus === 'activateEmployee'))}).length
                total += numExpenseEmployees * team.expenseLimit
            }
        });
        console.log("Total: "+total)
        // setBalanceRequired(total)
        if(total > 0){
            setPercent(parseFloat((issuingBalance * 100 / total).toFixed(1)))
        }else{
            setPercent(0)
        }
    }, [appContext.teams, appContext.employees, issuingBalance])

    // useEffect(() => {
    //     console.log(currentReceiptAmount)
    //     console.log(currentUploadDays)
    // }, [currentUploadDays, currentReceiptAmount])

    function onAmountInput(event, value){
        setCurrentReceiptAmount(Number(value.value))
    }

    function onDaysInput(event, value){
        setCurrentUploadDays(Number(value.value))   
    }

    function onCancel(event, data){
        setCurrentReceiptAmount(minimumReceiptAmount);
        setCurrentUploadDays(receiptUploadDays);
    }

    function onSave(event, date){
        setSaveModal(true)
    }

    const saveModalCloseHandler = () => {
        setSaveModal(false);
        setCurrentReceiptAmount(minimumReceiptAmount);
        setCurrentUploadDays(receiptUploadDays);
    }

    const saveModalConfirmHandler = async () => {
        await axios.post(url + '/organization/update-expense-settings', {minimumReceiptAmount: currentReceiptAmount, receiptUploadDays: currentUploadDays}, {
            headers: {
                Authorization: "Bearer " + accessToken,
            }
        }).then(response => {
            if(response.status === 200){
                console.log(response);
                appContext.setOrganizationPartialInfo({...appContext.organization, minimumReceiptAmount: currentReceiptAmount, receiptUploadDays: currentUploadDays})
                setMinimumReceiptAmount(currentReceiptAmount);
                setReceiptUploadDays(currentUploadDays);
                setSaveModal(false);
                setApiSuccessModal(true)
            }else{
                setSaveModal(false);
                setApiFailureModal(true)
            }
        }).catch(error => {
            setSaveModal(false);
            setApiFailureModal(true);
        })
        
    }

    return (
        <div style={{paddingRight:"4%", paddingLeft: '2%'}}>
            {appContext.loading && (<Dimmer active inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>)}
            <div className="ui grid" style={{display:'flex', flex:1, flexDirection: 'column', marginTop: 40, height: '100%'}}>
                <div className="sixteen column row" style={{display:'flex', flex:2, flexDirection: 'row', fontSize: 36, fontStyle: 'SFProText-Medium'}}>
                    Account Balance
                </div>
                <div className="sixteen column row" style={{display:'flex', flex:2, flexDirection: 'row', paddingTop: 15, alignItems:'center'}}>
                    <div style={{display:'flex', flex: 5, flexDirection: 'row', alignItems:'center'}}>
                        <div style={{display:'flex', flex: 4.7, flexDirection: 'row', paddingTop:20, paddingBottom: -20}}>
                            <Progress percent={percent} success size='big' style={{ width: '100%' }}/>
                        </div>
                        <div style={{display:'flex', flex: 1, flexDirection: 'column', paddingLeft: 15, }}>
                            <div style={{display:'flex', flex: 1, flexDirection: 'row', fontStyle:'SFProText-Medium', fontSize: 24, fontWeight: 500, paddingLeft: '10%'}}>
                                {percent}%
                            </div>
                            <div style={{display:'flex', flex: 1, flexDirection: 'row', fontStyle: 'SFProText-Light', fontSize: 12, fontWeight: 300}}>
                                as of {dateToDisplay}
                            </div>
                        </div>
                    </div>
                    <div style={{display:'flex', flex: 0.8, flexDirection: 'column', backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 5, padding:10, paddingLeft:20, }}>
                        <div style={{display:'flex', flex: 1.5, flexDirection: 'row', fontStyle:'SFProText-Light', fontSize:14, paddingRight: 20}}>
                                A 10% minimum balance required at all times.
                        </div>
                        {/* <div style={{display:'flex', flex: 2, flexDirection: 'row', fontStyle:'SFProText-Light', fontSize:14}}>
                                required at all times.
                        </div> */}
                    </div>
                </div>
                <div className="sixteen column row" style={{marginTop: -40, display:'flex', flex:2, flexDirection: 'row', fontStyle: 'SFProText-Light', fontSize: 12, paddingLeft: 12}}>
                    Funds are stored in a zero interest account.
                </div>
                <div className="sixteen column row" style={{marginTop: 20, display:'flex', flex:2, flexDirection: 'column', fontStyle: 'SFProText-Light', fontSize: 24, paddingLeft: 12}}>
                    <div style={{flex:1, }}>Expenses Settings</div>
                    <div style={{flex:1}}><Divider /></div>
                </div>
                <div className="ui row" style={{marginTop: -10,}}>
                    {/* <div style={{ display:'flex', flex:1, justifyContent:'flex-start'}}> */}
                        <span style={{ alignSelf:'center', fontStyle: 'SFProText-Light', fontSize: 18, paddingRight: 5,}}>Receipts requested for transactions</span>
                        <span style={{ width: 138, }}>
                            <Input size='small' labelPosition='right' type='number' value={currentReceiptAmount} placeholder='00' onChange={(event, data) => onAmountInput(event, data)} style={{width: '50%',  }}>
                                <Label basic>$</Label>
                                <input min={10} max={75} style={{}}/>
                                <Label>.00</Label>
                            </Input>
                        </span>
                        <span style={{ paddingLeft: 5, alignSelf: 'center', fontStyle: 'SFProText-Light', fontSize: 18}}>and over.</span>
                        {/* <span style={{ paddingLeft: '5%', alignSelf: 'center', fontStyle: 'SFProText-Light', fontSize: 10, color:'red', display: (currentReceiptAmount < 10 || currentReceiptAmount > 75) ? 'block' : 'none'}}>* Amount should be between 10 and 75 (both inclusive).</span> */}
                    {/* </div> */}
                </div>
                <div className="sixteen column row" style={{ marginTop:'-1%', marginBottom:'-2%', fontStyle: 'SFProText-Medium', fontSize: 14, color:'rgba(244, 65, 54, 1)', opacity: (currentReceiptAmount < 10 || currentReceiptAmount > 75) ? 1 : 0}}>
                    * IRS mandates all business expense transactions over $75 must have a receipt.
                </div>
                <div className="ui row" style={{marginTop: 20,}}>
                    {/* <div style={{ display:'flex', flex:1, justifyContent:'flex-start'}}> */}
                        <span style={{ alignSelf:'center', fontStyle: 'SFProText-Light', fontSize: 18}}>Employees are required to upload receipts within</span>
                        <span style={{ width: 70, }}>
                            <Input size='small' type='number' placeholder='00' value={currentUploadDays}  min={7} onChange={(event, data) => onDaysInput(event, data)} style={{width: '95%', paddingLeft: 5}} />
                        </span>
                        <span style={{ paddingLeft: 3, alignSelf: 'center', fontStyle: 'SFProText-Light', fontSize: 18}}>days of Transaction.</span>
                        {/* <span style={{ paddingLeft: '5%', alignSelf: 'center', fontStyle: 'SFProText-Light', fontSize: 10, color:'red', display: currentUploadDays < 7 ? 'block' : 'none'}}>* Number of days should be greater than or equal to 5.</span> */}
                    {/* </div> */}
                </div>
                <div className="sixteen column row" style={{ marginTop:'-1%', fontStyle: 'SFProText-Medium', fontSize: 14, color:'rgba(244, 65, 54, 1)', opacity: currentUploadDays < 7  ? 1 : 0}}>
                    * Upload Receipt Days should be 7 or over.
                </div>
            </div>
            <footer style={{marginTop: "10%", display: 'flex', flex:1, justifyContent: 'flex-end'}}>
                    <div style={{ width: 100, marginRight: 30}}>
                        <Button color='grey' onClick={(event, data) => onCancel(event, data)} style={{width: 100,}}>Cancel</Button>
                    </div>
                    <div style={{ width: 100}}>
                        <Button color='green' disabled={(currentReceiptAmount===minimumReceiptAmount && 
                            currentUploadDays===receiptUploadDays) || 
                            currentReceiptAmount < 10 || currentReceiptAmount > 75 || currentUploadDays < 7} onClick={(event, data) => onSave(event, data)} style={{width: 100}}>Save</Button>
                    </div>
            </footer>
            <Modal dimmer={'blurring'} open={saveModal}
                   size="small" onClose={saveModalCloseHandler}>
                <Modal.Content style={{display: minimumReceiptAmount !== currentReceiptAmount ? 'block' : 'none'}}>
                    <p>You are about to update Minimum Amount for Receipt Upload from [{minimumReceiptAmount}] to [{currentReceiptAmount}].</p>
                </Modal.Content>
                <Modal.Content style={{display: receiptUploadDays !== currentUploadDays ? 'block' : 'none'}}>
                    <p>You are about to update Minimum Days for Receipt Upload from [{receiptUploadDays}] to [{currentUploadDays}].</p>
                </Modal.Content>
                <Modal.Actions className="center aligned">
                    <Button onClick={saveModalCloseHandler}>Cancel</Button>
                    <Button className="primary" content="Save"
                            onClick={saveModalConfirmHandler}/>
                </Modal.Actions>
            </Modal>

            <Modal dimmer={'blurring'} open={apiSuccessModal}
                   size="small" onClose={() => setApiSuccessModal(false)}>
                <Modal.Content>
                    <p>Details were Updated successfully.</p>
                </Modal.Content>
                <Modal.Actions className="center aligned">
                    <Button onClick={() => setApiSuccessModal(false)}>Close</Button>
                </Modal.Actions>
            </Modal>

            <Modal dimmer={'blurring'} open={apiFailureModal}
                   size="small" onClose={() => setApiFailureModal(false)}>
                <Modal.Content>
                    <p>There was some Error. Please try again.</p>
                </Modal.Content>
                <Modal.Actions className="center aligned">
                    <Button onClick={() => setApiFailureModal(false)}>Close</Button>
                </Modal.Actions>
            </Modal>

            {/* <Modal dimmer={'blurring'} open={incorrectInputModal}
                   size="mini" onClose={incorrectInputModalCloseHandler}>
                <Modal.Content style={{display: incorrectAmount ? 'block' : 'none'}}>
                    <p>You are about to update Minimum Amount for Receipt Upload from [{minimumReceiptAmount}] to [{currentReceiptAmount}].</p>
                </Modal.Content>
                <Modal.Content style={{display: incorrectDays ? 'block' : 'none'}}>
                    <p>You are about to update Minimum Days for Receipt Upload from [{receiptUploadDays}] to [{currentUploadDays}].</p>
                </Modal.Content>
                <Modal.Actions className="center aligned">
                    <Button onClick={incorrectInputModalCloseHandler}>Cancel</Button>
                </Modal.Actions>
            </Modal> */}
        </div>
    )
}